// ContentBlocks.jsx
import React from "react";

const ContentBlocks = ({ blocks }) => {
  return (
    <>
      {blocks.map((block, index) => {
        switch (block.type) {
            case "main-heading":
            return (
              <h2
                key={index}
                className="font-nunito font-bold text-[16px] leading-[100%] tracking-tight"
              >
                {block.content} :
              </h2>
            );

          case "heading":
            return (
              <h2
                key={index}
                className="font-nunito font-bold text-[14px] leading-[100%] tracking-tight"
              >
                {block.content}
              </h2>
            );

          case "paragraph":
            return (
              <p
                key={index}
                className="font-nunito font-semibold text-[13px] leading-[100%] text-[#808080]"
              >
                {block.content}
              </p>
            );

          case "bullets":
            return (
              <ul key={index} className="list-disc pl-5 space-y-1">
                {block.content.map((item, i) => (
                  <li
                    key={i}
                    className="font-nunito font-semibold text-[13px] leading-[100%] text-[#808080]"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            );

          default:
            return null;
        }
      })}
    </>
  );
};

export default ContentBlocks;
